import { Switch } from '@monorepo/shared/componentsV2/Switch';
import React from 'react';
import { useField } from 'react-final-form';

type EditCompactBooleanFieldValueProps = {
  className?: string;
  initialValue: string | undefined;
  label: string;
  name: string;
  required?: boolean;
  isLabelHidden?: boolean;
  isCompact?: boolean;
  isErrorTextHidden?: boolean;
  isSubtextHidden?: boolean;
};

/**
 * Compact boolean field that stores string values ("true"/"false") to match RadioGroupField.
 * This ensures compatibility when switching between compact and non-compact views.
 */
export function EditCompactBooleanFieldValue({
  className,
  initialValue,
  label,
  name,
  required,
  isLabelHidden,
  isCompact,
  isErrorTextHidden,
  isSubtextHidden,
}: EditCompactBooleanFieldValueProps) {
  const { input } = useField<string>(name, { initialValue });
  const isChecked = input.value === 'true';

  return (
    <Switch
      className={className}
      checked={isChecked}
      label={label}
      name={name}
      required={required}
      isLabelHidden={isLabelHidden}
      isCompact={isCompact}
      isErrorTextHidden={isErrorTextHidden}
      isSubtextHidden={isSubtextHidden}
      onChange={(e) => {
        input.onChange(e.target.checked ? 'true' : 'false');
      }}
    />
  );
}
